import * as React from "react";
import styles from "./qA.module.scss";
import DotGrid from "../../../../components/dot-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight, faCaretDown } from "@fortawesome/free-solid-svg-icons";

const qas = [
  {
    q: "Will it bruise my skin?",
    a:
      "You will not experience any bruising as long as you keep moving the tip around. Do not let it stay on the same spot for more than 3 seconds.  "
  },
  {
    q: "Is it safe to use on sensitive skin? ",
    a:
      "Yes, our product has different modes and tips designed especially for sensitive skin. We suggest you use the small round tip along with the lowest suction power. Make sure you don’t leave the device on the same spot for more than a few seconds and stop if you notice any irritation."
  },
  {
    q: "Does it hurt?",
    a:
      "There's no pain involved at all. The treatments are efficient and gentle at the same time."
  },
  {
    q: "Is the suction strong enough to pull out blackheads?",
    a:
      "You can choose your preferred suction strength with the 3 options. If you've opened up your pores our product will be able to pull out all the gunk inside."
  },
  {
    q: "Will this work to clean out the pores on my nose?",
    a:
      "Yes our product work especially well on the nose since that's where most blackheads usually are located. "
  },
  {
    q:
      "Will the product leave a little redness on my face after the first use?",
    a:
      "Yes, a little redness is to be expected. No worries though, it will go away after 10-20 minutes."
  },
  {
    q: "How often should I use the product?",
    a:
      "Once or twice a week. Overusing the product can cause bruising on your skin. "
  },
  {
    q: "I have dry skin. Would this product be safe for me to use?",
    a:
      "The product is safe to use with dry skin. Something we always recommend for our users is to moisturize after a treatment."
  }
];

const QA = () => {
  return (
    <div className={styles.qAs}>
      <div className={styles.content}>
        <h4>Frequently Asked Questions</h4>

        <div className={styles.list}>
          {qas.map((qa: { q: string; a: string }, i: number) => (
            <QAItem key={qa.q} {...qa} i={i} />
          ))}
        </div>

        <DotGrid className={styles.grid} size={20} />
      </div>
    </div>
  );
};

const QAItem = ({ q, a, i }: { q: string; a: string; i: number }) => {
  const [open, toggle] = React.useState(i === 0);

  return (
    <div className={styles.qA}>
      <h5
        onClick={() => {
          toggle(!open);
        }}
      >
        {q}{" "}
        <i>
          <FontAwesomeIcon icon={open ? faCaretDown : faCaretRight} />
        </i>
      </h5>
      {open && <p>{a}</p>}
    </div>
  );
};

export default QA;
